import classNames from 'classnames';
import dayjs from 'dayjs';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { outboundDial } from '../../api/queue-control';
import { HasClassName } from '../../component-utils';
import { useSelector } from '../../hook-utils';
import { DispositionCodeAction } from '../../model';
import { actions } from '../../store';
import { selectMyData, selectMyRegion } from '../../store/reducers/config';
import { selectMedia } from '../../store/reducers/media';
import { getOutBoundById } from '../../store/reducers/outbound';
import Button from '../Button';
import { RelativeLongFormatDateTime } from '../CallsPage';
import DateTimePicker from '../DateTimePicker';
import DropdownButton from '../DropdownButton';
import { MenuItem } from '../Menu';
import { ParkCallControlButtons } from './FacebookView';
import { replaceScriptingVars } from './MediaPage';
import './OutboundView.scss';


interface Props extends HasClassName {
  mediaId?: string
  mediaItemId: string
}


export default function OutboundView({ className, mediaId, mediaItemId }: Props) {
  const dispatch = useDispatch()
  const media = useSelector(s => mediaId && selectMedia(s, mediaId))
  const region = useSelector(selectMyRegion)
  const config = useSelector(selectMyData)
  const outbound = useSelector(s => getOutBoundById(s, mediaItemId))

  useEffect(() => {
    if (!outbound) {
      dispatch(actions.fetchOutboundDetailsRequest(mediaId ? mediaId : '', mediaItemId))

    } else if (outbound && !outbound.codes) {
      dispatch(actions.fetchOutboundCodesRequest(mediaId ? mediaId : '', mediaItemId, outbound.campaignId))
    }
  }, [dispatch, mediaId, mediaItemId, outbound])

  if (!outbound || !outbound.codes) { return <>loading...</> }

  if (!outbound.selectedCode && outbound.codes) {
    dispatch(actions.setDispositionCode(mediaItemId, outbound.codes[0]))
  }


  if (!region || !config) return null

  return <>
    <div key={outbound.contactId} className={classNames(className && className, 'OutboundView')}>
      {media && <div className='MediaControl toolbar'>
        <ParkCallControlButtons media={media} />
      </div>}
      <div className='caller-details'>
        <table>
          <tbody>
            <tr>
              <td>Campaign</td>
              <td>{outbound.campaignName}</td>
            </tr>
            <tr>
              <td>Customer</td>
              <td>{outbound.contactName}</td>
            </tr>
            <tr>
              <td>Primary</td>
              <td>{outbound.primaryTelephoneNumber}</td>
            </tr>
            <tr>
              <td>Secondary</td>
              <td>{outbound.secondaryTelephoneNumber}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>{outbound.emailAddress}</td>
            </tr>
            <tr>
              <td>URL</td>
              <td>{outbound.url}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className='buttons'>
        <Button primary className={className} disabled={!media} onClick={() => {
          if (media) {
            outboundDial(media.id, outbound.contactId, outbound.primaryTelephoneNumber)
          }
        }}>Dial Primary</Button>
        <Button className={className} disabled={!media} onClick={() => {
          if (media) {
            outboundDial(media.id, outbound.contactId, outbound.secondaryTelephoneNumber)
          }
        }}>Dial Secondary</Button>
        <Button className={className} onClick={(e) => {
          if (media) {
            e.preventDefault();
            e.stopPropagation();
            dispatch(actions.ccMailto(outbound.emailAddress))
          }
        }} disabled={outbound.emailAddress === '' || !media}>Email</Button>
        <Button className={className} onClick={() => {
          if (media) {
            window.open(replaceScriptingVars(outbound.url, media, config, region))
          }
        }} disabled={outbound.url === '' || !media} >Open URL</Button>
      </div>
      <div className='comment'>
        <div className='header-one-bold' >Comment</div>
        <textarea disabled value={outbound.contactNote} />
      </div>

      <div className='controls'>
        <div className='header-one-bold'>Disposition</div>
        <div className='header-one-bold'>{outbound.selectedCode && outbound.selectedCode.action === DispositionCodeAction.Defer && 'Defer to'}</div>
        <DropdownButton className='code' disabled={!media} setWidth items={outbound.codes && outbound.codes.map(code => <MenuItem key={code.iD} onClick={() => {
          dispatch(actions.setDispositionCodeDeferDate(mediaItemId, dayjs().add(code.deferMinutes, 'm').valueOf()))
          dispatch(actions.setDispositionCode(mediaItemId, code))
        }}>{code.name}</MenuItem>)}>{outbound.selectedCode && outbound.selectedCode.name}</DropdownButton>
        {outbound.selectedCode && outbound.selectedCode.action === DispositionCodeAction.Defer && outbound.deferDate && <DateTimePicker value={outbound.deferDate} onChange={(value) => {
          dispatch(actions.setDispositionCodeDeferDate(mediaItemId, value))
        }} disabled={!outbound.selectedCode.canEditDeferDateTime} />}
      </div>

      {
        outbound.sessions.length > 0 &&
        <div className="results">
          <div className='header'>
            <div>Date</div>
            <div>Disposition</div>
            <div>Deferred Until</div>
          </div>
          {outbound.sessions.map((session) => {
            const selection = outbound.codes && outbound.codes.find(x => x.iD === session.dispositionCodeId)
            return <div className='result' key={session.id}>
              <div>
                {typeof session.startedAtUtc === 'number' && <RelativeLongFormatDateTime date={session.startedAtUtc} />}
              </div>
              <div>
                {!selection ? '' : selection.name}
              </div>
              <div>
                {typeof session.deferredUntilUtc === 'number' ? <RelativeLongFormatDateTime date={session.deferredUntilUtc} /> : ''}
              </div>
            </div>
          })}
        </div>
      }
    </div>
  </>
}
